import { RootRoute } from "../routes";

export default function MainLayout() {
    return (
        <main className="h-full w-full">
            <RootRoute />
        </main>
    )
}